import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Stack } from '../../Stack';
import { SoftConfigThemeSchema } from '../../_theme';
const defaultTheme = SoftConfigThemeSchema.parse();
const PlannedMaintenanceStyles = createGlobalStyle `
  html,body {
    background-color: ${defaultTheme.colors.primary.dark};
    flex-grow:1;
  }

  h1 {
    color: ${defaultTheme.colors.white};
    text-align: center;
    padding-left: 3%;
    padding-right: 3%;
  }
`;
export const PlannedMaintenance = ({ heading = 'Planned maintenance: we are currently performing scheduled maintenance. The Tumelo platform will be unavailable until approximately 16:00.', logoSrc, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PlannedMaintenanceStyles, null),
        React.createElement(Stack, { alignItems: "center", mt: "3.2rem" },
            React.createElement("img", { alt: "tumelo", src: logoSrc, width: "250", height: "55" }),
            React.createElement("h1", null, heading))));
};
